import React from 'react';
import Helmet from 'react-helmet';
import Navbar from '../Navbar';
import Footer from '../Footer';
import styles from './index.sass';
import phonesPng from './images/phones_2x.png';

class Download extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requestStatus: null
    };
  }

  componentDidMount() {
    if(typeof branch !== 'undefined') {

    } else {
      console.log('branch is undefined');
    }
  }

  handleOnSubmit(e) {
    e.stopPropagation();
    e.preventDefault();

    let phone = this.refs.phone.value;
    if(!phone || typeof branch === 'undefined') {
      return;
    }

    let linkData = {
      tags: [],
      channel: 'Website',
      feature: 'TextMeTheApp',
      data: {}
    };
    let options = {};

    this.setState({requestStatus: 'loading'});
    branch.init('key_live_lhiOuXnCvyEp2YKfDW2buaddArc8w58C', {}, (err, data) => {
      if(err) {
        console.log('ERROR: ', err);
        if(typeof Bugsnag !== 'undefined') {
          Bugsnag.notifyException(err, 'Branch Error');
        }
        this.setState({requestStatus: 'error'});
        return alert('Sorry, something went wrong.');
      }
      branch.sendSMS(phone, linkData, options, (err, result) => {
        if(err) {
          console.log('ERROR: ', err);
          if(typeof Bugsnag !== 'undefined') {
            Bugsnag.notifyException(err, 'Branch Error');
          }
          this.setState({requestStatus: 'error'});
          return alert('Sorry, something went wrong.');
        }
        this.setState({requestStatus: 'done'});
      });
    });
  }

  render() {
    let helmetProps = {
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'},
      ],
      script: [
        {src: 'https://cdn.branch.io/branch-v1.8.8.min.js', type: 'text/javascript'}
      ]
    };
    let {requestStatus} = this.state;
    let submitButtonText = 'Send me the app';
    let disabled = false;
    if(requestStatus === 'loading') {
      submitButtonText = 'Sending SMS...';
      disabled = true;
    } else if(requestStatus === 'done') {
      submitButtonText = 'SMS Sent!';
      disabled = true;
    }

    return (
      <div className={styles.container}>
        <Helmet {...helmetProps} />
        <form className={styles.form} onSubmit={this.handleOnSubmit.bind(this)}>
          <input className={styles.input} ref="phone" type="tel" placeholder="(123) 123-4567" disabled={disabled} autoFocus={true} />
          <button className={styles.submitButton} type="submit" disabled={disabled}>{submitButtonText}</button>
        </form>
        <p className={styles.instructionText}>You'll receive a SMS with a link to download the app</p>
        <img className={styles.phones} src={phonesPng} alt="Banquet by Delectable for iPhone and Android" />
      </div>
    );
  }
}

export default Download;



// WEBPACK FOOTER //
// banquet/components/Download/index.js